import * as React from 'react';
import { useInfrastructureProps } from './hooks';
import { InfrastructureContainer } from './InfrastructureContainer';
import { IInfrastructureContainerLoadProps } from './utils';
import { RefWrapper } from '../../components/packages/RefWrapper';

export const InfrastructureContainerLoad: React.FC<IInfrastructureContainerLoadProps> = ({ refWrapper }) => {
  const infrastructureProps = useInfrastructureProps();

  if (!infrastructureProps) {
    return null;
  }

  return refWrapper(
    <RefWrapper>
      <InfrastructureContainer {...infrastructureProps} />
    </RefWrapper>,
  );
};
